import { Column } from "../../../../core/components/Column";
import { TextComponent } from "../../../../core/components/TextComponent";

interface TecnoporSectionProps {
	title: string;
	description: React.ReactNode;
	imageSrc: string;
	imageAlt: string;
	className?: string;
}

export const CardPlastic: React.FC<TecnoporSectionProps> = ({ title, description, imageSrc, imageAlt, className = "" }) => {
	return (
		<Column
			className={`bg-white p-4 md:p-5 rounded-lg gap-4 ${className}`}
			data-sal="slide-up"
			data-sal-duration="1000"
			// {...(dataSal ? { "data-sal": dataSal } : {})}
			// {...(dataSalDuration ? { "data-sal-duration": dataSalDuration } : {})}
		>
			<TextComponent
				variant="h1"
				className="font-title text-center !leading-none truncate"
			>
				{title}
			</TextComponent>
			{description}
			<img
				className="object-cover rounded-lg mt-auto"
				src={imageSrc}
				alt={imageAlt}
			/>
		</Column>
	);
};
